module.exports = __webpack_public_path__ + "img/linkedin-icon.44f3fccf.svg";